import { render, staticRenderFns } from "./VendorBidStatusCollapse.vue?vue&type=template&id=2c7916fb&scoped=true&"
import script from "./VendorBidStatusCollapse.vue?vue&type=script&lang=js&"
export * from "./VendorBidStatusCollapse.vue?vue&type=script&lang=js&"
import style0 from "./VendorBidStatusCollapse.vue?vue&type=style&index=0&id=2c7916fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7916fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7916fb')) {
      api.createRecord('2c7916fb', component.options)
    } else {
      api.reload('2c7916fb', component.options)
    }
    module.hot.accept("./VendorBidStatusCollapse.vue?vue&type=template&id=2c7916fb&scoped=true&", function () {
      api.rerender('2c7916fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/VendorBidStatusCollapse.vue"
export default component.exports